import { Translate } from '@dreryk/react-common';
import { CheckIcon, CloseIcon, IconFillColor, IconSize, IconWrapper, StyledFlex } from '@dreryk/react-components';

import { visitPatientPregnancyStatusTranslationKeys } from '../../../translations';

type GynecologicalInterviewPregnancyConfirmationMarkProps = {
   readonly confirmed: boolean;
};

export const GynecologicalInterviewPregnancyConfirmationMark = (
   props: GynecologicalInterviewPregnancyConfirmationMarkProps
): JSX.Element => {
   return (
      <StyledFlex gap={'4px'} alignItems={'center'}>
         <IconWrapper
            testId={'pregnancyConfirmed'}
            size={IconSize.SMALLEST}
            fillColor={props.confirmed ? IconFillColor.PRIMARY : IconFillColor.ERROR}
         >
            {props.confirmed ? <CheckIcon /> : <CloseIcon />}
         </IconWrapper>
         <Translate>
            {props.confirmed
               ? visitPatientPregnancyStatusTranslationKeys.pregnancyConfirmed
               : visitPatientPregnancyStatusTranslationKeys.pregnancyUnconfirmed}
         </Translate>
      </StyledFlex>
   );
};
